function Research2019() {

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-16">2019</div>

            <div className="w-full">
                <div className="flex">
                    <div className="w-16">Dec</div>
                    <div className="w-full">
                        <p><a href="https://sites.google.com/view/jpoissongeometry19/" target='_blank'>“Commutative and cocommutative Kitaev lattice model and homology theory.”</a></p>
                        <p>Poisson geometry and related topics, Ritsumeikan University</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Nov</div>
                    <div className="w-full">
                        <p><a href="" target='_blank'>“A characterization of convective precipitation by persistent homology.”</a></p>
                        <p>FMSP Research Seminar on Social and Mathematical practice, University of Tokyo</p>
                    </div>
                </div>

                <div className="flex mt-2">
                    <div className="w-16">Feb</div>
                    <div className="w-full">
                        <p><a href="https://kansai-gauge.squares.net/kgs15-19.html" target='_blank'>“A generalization of Dijkgraaf-Witten theory.”</a></p>
                        <p>Kansai Gauge theory Seminar, Kyoto University</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Research2019;